import React from 'react';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import PublicLayout from './components/public/PublicLayout';
import AdminLayout from './components/admin/AdminLayout';

function App() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <PublicLayout />;
  }

  return <AdminLayout />;
}

export default App;